"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GetTheme = void 0;
var Buttons = _interopRequireWildcard(require("./ThemeComponents/buttons"));
var Cards = _interopRequireWildcard(require("./ThemeComponents/cards"));
var Headings = _interopRequireWildcard(require("./ThemeComponents/headings"));
var _styles = require("@mui/material/styles");
var _object = require("../utils/type-checks/object");
var _theme = _interopRequireDefault(require("./../scss/theme.scss"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const merge = require("deepmerge"),
  /**
  * Constructs MUI Custom Theme object
  *
  * @name GetTheme
  * @param {object} customTheme Optional custom MUI Theme object to combine with default values
  * @returns {object} MUI Theme object combining MUI Defaults, site defaults, and custom theme
  */
  GetTheme = customTheme => {
    const primaryButton = merge({}, Buttons.primaryButton()),
      secondaryButton = merge({}, Buttons.secondaryButton()),
      outlineButton = merge({}, Buttons.outlineButton()),
      tertiaryButton = merge({}, Buttons.tertiaryButton()),
      ctalink = merge({}, Buttons.ctalink()),
      ctalinkWithArrow = merge({}, Buttons.ctalinkWithArrow()),
      rteCardWithBorder = merge({}, Cards.rteCardWithBorder()),
      defaultTheme = {
        identifier: "generalTheme",
        breakpoints: {
          // Assumes all measurements are in pixels
          values: {
            xs: parseInt(_theme.default.breakpoint_xs, 10),
            sm: parseInt(_theme.default.breakpoint_sm, 10),
            md: parseInt(_theme.default.breakpoint_md, 10),
            lg: parseInt(_theme.default.breakpoint_lg, 10),
            xl: parseInt(_theme.default.breakpoint_xl, 10)
          }
        },
        components: {
          MuiCssBaseline: {
            styleOverrides: {
              b: {
                fontFamily: _theme.default.fontPrimaryBold,
                fontWeight: "normal"
              },
              strong: {
                fontFamily: _theme.default.fontPrimaryBold,
                fontWeight: "normal"
              }
            }
          },
          MuiButton: {
            defaultProps: {
              disableRipple: true
            },
            variants: [{
              props: {
                variant: "primary"
              },
              style: {
                ...primaryButton
              }
            }, {
              props: {
                variant: "secondary"
              },
              style: {
                ...secondaryButton
              }
            }, {
              props: {
                variant: "outline"
              },
              style: {
                ...outlineButton
              }
            }, {
              props: {
                variant: "tertiary"
              },
              style: {
                ...tertiaryButton
              }
            }, {
              props: {
                variant: "ctalink"
              },
              style: {
                ...ctalink
              }
            }, {
              props: {
                variant: "ctalinkWithArrow"
              },
              style: {
                ...ctalinkWithArrow
              }
            }]
          },
          MuiCard: {
            variants: [{
              props: {
                variant: "rteCardWithBorder"
              },
              style: {
                ...rteCardWithBorder
              }
            }]
          }
        },
        headings: {
          InteriorPageHeading: {
            ...merge({}, Headings.InteriorPageHeading().base),
            ".Heading__caption--isInteriorPageHeading": merge({}, Headings.InteriorPageHeading().caption),
            ".Heading__content--isInteriorPageHeading": merge({}, Headings.InteriorPageHeading().content)
          },
          InteriorPageHeadingCentered: {
            ...merge({}, Headings.InteriorPageHeadingCentered().base),
            ".Heading__caption--isInteriorPageHeadingCentered": merge({}, Headings.InteriorPageHeadingCentered().caption),
            ".Heading__content--isInteriorPageHeadingCentered": merge({}, Headings.InteriorPageHeadingCentered().content)
          },
          InteriorPageSubHeading: {
            ...merge({}, Headings.InteriorPageSubHeading().base),
            ".Heading__caption--isInteriorPageSubHeading": merge({}, Headings.InteriorPageSubHeading().caption),
            ".Heading__content--isInteriorPageSubHeading": merge({}, Headings.InteriorPageSubHeading().content)
          },
          CardHeading: {
            ...merge({}, Headings.CardHeading().base),
            ".Heading__caption--isCardHeading": merge({}, Headings.CardHeading().caption),
            ".Heading__content--isCardHeading": merge({}, Headings.CardHeading().content)
          },
          RTEHeading: {
            ...merge({}, Headings.RTEHeading().base),
            ".Heading__caption--isRTEHeading": merge({}, Headings.RTEHeading().caption),
            ".Heading__content--isRTEHeading": merge({}, Headings.RTEHeading().content)
          },
          RTESubHeading: {
            ...merge({}, Headings.RTESubHeading().base),
            ".Heading__caption--isRTESubHeading": merge({}, Headings.RTESubHeading().caption),
            ".Heading__content--isRTESubHeading": merge({}, Headings.RTESubHeading().content)
          }
        },
        palette: {
          primary: {
            main: _theme.default.color_primary
          },
          secondary: {
            main: _theme.default.color_secondary
          },
          error: {
            main: _theme.default.color_error
          },
          text: {
            primary: _theme.default.color_text_primary,
            secondary: _theme.default.color_text_secondary
          },
          background: {
            ad: _theme.default.color_ad_background
          },
          footer: {
            border: _theme.default.color_footer_border,
            separator: _theme.default.color_footer_separator
          },
          contrastThreshold: 4.5
        },
        mixins: {
          container: {
            inner: {
              margin: _theme.default.container_inner_margin,
              minWidth: {
                xs: `calc(${_theme.default.min_width} - 4rem)`,
                lg: `calc(${_theme.default.min_width} - 2rem)`
              },
              maxWidth: _theme.default.breakpoint_lg
            },
            outer: {
              minWidth: _theme.default.min_width,
              maxWidth: "100% !important",
              padding: {
                xs: _theme.default.container_outer_padding_xs,
                lg: _theme.default.container_outer_padding_lg
              }
            }
          },
          landingPage: {
            backgroundColor: _theme.default.landing_page_background_color
          },
          focus: {
            boxShadow: _theme.default.focus_shadow,
            outline: _theme.default.focus_outline,
            outlineOffset: _theme.default.focus_outline_offset
          },
          headings: {
            InteriorPageHeading: {
              base: merge({}, Headings.InteriorPageHeading().base),
              caption: merge({}, Headings.InteriorPageHeading().caption),
              content: merge({}, Headings.InteriorPageHeading().content)
            },
            InteriorPageSubHeading: {
              base: merge({}, Headings.InteriorPageSubHeading().base),
              caption: merge({}, Headings.InteriorPageSubHeading().caption),
              content: merge({}, Headings.InteriorPageSubHeading().content)
            },
            CardHeading: {
              base: merge({}, Headings.CardHeading().base),
              caption: merge({}, Headings.CardHeading().caption),
              content: merge({}, Headings.CardHeading().content)
            },
            RTEHeading: {
              base: merge({}, Headings.RTEHeading().base),
              caption: merge({}, Headings.RTEHeading().caption),
              content: merge({}, Headings.RTEHeading().content)
            },
            RTESubHeading: {
              base: merge({}, Headings.RTESubHeading().base),
              caption: merge({}, Headings.RTESubHeading().caption),
              content: merge({}, Headings.RTESubHeading().content)
            }
          },
          hiddenVisually: {
            left: "-9999px !important",
            overflow: "hidden !important",
            position: "absolute !important",
            top: "-9999px !important"
          },
          hiddenVisuallyUndo: {
            left: "0 !important",
            overflow: "visible !important",
            position: "static !important",
            top: "0 !important"
          },
          navigation: {
            desktop: {
              primaryLinkColor: _theme.default.navigation_primary_link_color,
              primaryLinkColorHover: _theme.default.navigation_primary_link_color_hover,
              primaryBorderColor: _theme.default.navigation_primary_border_color,
              primaryBorderColorHover: _theme.default.navigation_primary_border_color_hover,
              secondaryLinkColor: _theme.default.navigation_secondary_link_color,
              secondaryLinkColorHover: _theme.default.navigation_secondary_link_color_hover,
              tertiaryLinkColor: _theme.default.navigation_tertiary_link_color,
              tertiaryLinkColorHover: _theme.default.navigation_tertiary_link_color_hover,
              signInLinkColor: _theme.default.navigation_sign_in_link_color,
              signInLinkColorHover: _theme.default.navigation_sign_in_link_color_hover,
              signInLinkBackgroundColor: _theme.default.navigation_sign_in_link_background_color,
              signInLinkBackgroundColorHover: _theme.default.navigation_sign_in_link_background_color_hover,
              signInButtonColor: _theme.default.navigation_sign_in_button_color,
              signInButtonColorHover: _theme.default.navigation_sign_in_button_color_hover,
              signInButtonBackgroundColor: _theme.default.navigation_sign_in_button_background_color,
              signInButtonBackgroundColorHover: _theme.default.navigation_sign_in_button_background_color_hover
            },
            mobile: {
              linkColor: _theme.default.navigation_mobile_link_color,
              linkColorInverse: _theme.default.navigation_mobile_link_color_inverse,
              linkBackgroundColorHover: _theme.default.navigation_mobile_link_background_color_hover,
              linkBackgroundColorHoverInverse: _theme.default.navigation_mobile_link_background_color_hover_inverse,
              linkColorHover: _theme.default.navigation_mobile_link_color_hover,
              linkColorHoverInverse: _theme.default.navigation_mobile_link_color_hover_inverse,
              backButtonColor: _theme.default.navigation_mobile_back_button_color,
              backButtonColorHover: _theme.default.navigation_mobile_back_button_color_hover,
              backButtonBackgroundColor: _theme.default.navigation_mobile_back_button_background_color,
              backButtonBackgroundColorHover: _theme.default.navigation_mobile_back_button_background_color_hover,
              signInLinkColor: _theme.default.navigation_mobile_sign_in_link_color,
              signInLinkColorHover: _theme.default.navigation_mobile_sign_in_link_color_hover,
              signInLinkBackgroundColor: _theme.default.navigation_mobile_sign_in_link_background_color,
              signInLinkBackgroundColorHover: _theme.default.navigation_mobile_sign_in_link_background_color_hover,
              headingUnderline: _theme.default.navigation_mobile_heading_underline,
              drawerPaperBackgroundColor: _theme.default.navigation_mobile_drawer_paper_background_color,
              drawerPaperBackgroundColorInverse: _theme.default.navigation_mobile_drawer_paper_background_color_inverse,
              drawerPaperColor: _theme.default.navigation_mobile_drawer_paper_color,
              drawerPaperColorInverse: _theme.default.navigation_mobile_drawer_paper_color_inverse,
              drawerModalBackgroundColor: _theme.default.navigation_mobile_drawer_modal_background_color,
              drawerButtonBackgroundColorHover: _theme.default.navigation_mobile_drawer_button_background_color_active,
              drawerButtonBackgroundColorHoverInverse: _theme.default.navigation_mobile_drawer_button_background_color_active_inverse,
              dividerColor: _theme.default.navigation_mobile_divider_color,
              dividerColorInverse: _theme.default.navigation_mobile_divider_color_inverse,
              closeIconColor: _theme.default.navigation_mobile_close_icon_color,
              buttonIconColor: _theme.default.navigation_mobile_button_icon_color,
              logoBackgroundColor: _theme.default.navigation_mobile_logo_background_color,
              indicatorBackgroundColor: _theme.default.navigation_mobile_new_indicator_background_color,
              indicatorColor: _theme.default.navigation_mobile_new_indicator_color
            }
          },
          overlay: {
            iconCard: _theme.default.icon_card_background_hover_overlay
          },
          variantButtons: {
            primary: {
              ...primaryButton
            },
            secondary: {
              ...secondaryButton
            },
            outline: {
              ...outlineButton
            },
            tertiary: {
              ...tertiaryButton
            },
            ctalink: {
              ...ctalink
            },
            ctalinkWithArrow: {
              ...ctalinkWithArrow
            }
          },
          variantCards: {
            border: {
              ...rteCardWithBorder
            }
          }
        },
        shape: {
          // Assumes style in "rem" and HTML font size = 10px
          borderRadius: parseFloat(_theme.default.shape_border_radius) * 10
        },
        breadcrumb: {
          backgroundColor: _theme.default.breadcrumb_background_color,
          color: _theme.default.breadcrumb_color,
          colorHover: _theme.default.breadcrumb_color_hover,
          fontFamily: {
            default: _theme.default.breadcrumb_font_family_default,
            last: _theme.default.breadcrumb_font_family_last
          },
          fontSize: _theme.default.breadcrumb_font_size
        },
        calculator: {
          linearProgress: {
            backgroundColor: _theme.default.calculator_linear_progress_color_background,
            color: _theme.default.calculator_linear_progress_color,
            subheadingColor: _theme.default.calculator_subheading_caption_color
          }
        },
        quiz: {
          linearProgress: {
            backgroundColor: _theme.default.quiz_linear_progress_color_background,
            color: _theme.default.quiz_linear_progress_color,
            subheadingColor: _theme.default.quiz_subheading_caption_color
          },
          modal: {
            backgroundColor: _theme.default.quiz_modal_background_color,
            borderColor: _theme.default.quiz_modal_border_color,
            closeButtonColor: _theme.default.quiz_modal_close_button_color
          },
          namePanel: {
            headingColor: _theme.default.quiz_name_panel_heading_color
          },
          results: {
            score: {
              backgroundColor: _theme.default.quiz_results_score_count_background_color
            },
            title: {
              backgroundColor: _theme.default.quiz_results_title_background_color,
              borderColor: _theme.default.quiz_results_title_border_color,
              printIcon: {
                color: _theme.default.quiz_results_title_print_icon_color
              },
              printText: {
                background: _theme.default.quiz_results_title_print_text_background,
                color: _theme.default.quiz_results_title_print_text_color,
                fontFamily: _theme.default.quiz_results_title_print_text_font_family
              },
              user: {
                borderRight: {
                  color: _theme.default.quiz_results_title_user_border_right_color
                },
                icon: {
                  backgroundColor: _theme.default.quiz_results_title_user_icon_background_color,
                  color: _theme.default.quiz_results_title_user_icon_color
                },
                text: {
                  fontFamily: _theme.default.quiz_results_title_user_text_font_family
                }
              }
            }
          }
        },
        search: {
          inputBorderColor: _theme.default.search_input_border_color,
          inputPlaceholderColor: _theme.default.search_input_placeholder_color,
          closeButtonColor: _theme.default.search_close_button_color,
          backgroundGradients: _theme.default.search_background_gradients
        },
        skipLinks: {
          backgroundColor: _theme.default.skipLinks_background_color,
          border: _theme.default.skipLinks_border,
          fontFamily: _theme.default.skipLinks_font_family,
          fontSize: _theme.default.skipLinks_font_size
        },
        typography: {
          fontFamily: _theme.default.fontPrimary,
          // Assumes style in "rem" and HTML font size = 10px
          fontSize: parseFloat(_theme.default.font_size) * 10,
          // Assumes value is a percentage
          htmlFontSize: 16 * (parseFloat(_theme.default.html_font_size) / 100),
          body1: {
            fontFamily: _theme.default.fontPrimary,
            fontSize: _theme.default.font_size,
            lineHeight: _theme.default.line_height,
            hyphens: _theme.default.hyphens
          }
        },
        // Custom object to pass font families into theme object
        fontFamilies: {
          bold: _theme.default.fontPrimaryBold,
          boldItalic: _theme.default.fontPrimaryBoldItalic,
          default: _theme.default.fontPrimary,
          extraBold: _theme.default.fontPrimaryExtrabold,
          extraBoldItalic: _theme.default.fontPrimaryExtraboldItalic,
          italic: _theme.default.fontPrimaryItalic,
          light: _theme.default.fontPrimaryLight,
          lightItalic: _theme.default.fontPrimaryLightItalic,
          robotoSlab: _theme.default.fontRobotoSlab,
          robotoSlabBold: _theme.default.fontRobotoSlabBold,
          semiBold: _theme.default.fontPrimarySemibold,
          semiBoldItalic: _theme.default.fontPrimarySemiboldItalic
        },
        minWidth: _theme.default.min_width,
        contentSpacing: {
          mobileHeader: _theme.default.content_header_spacing_mobile,
          desktopHeader: _theme.default.content_header_spacing_desktop,
          mobileInterior: _theme.default.content_interior_spacing_mobile,
          desktopInterior: _theme.default.content_interior_spacing_desktop,
          mobileFooter: _theme.default.content_footer_spacing_mobile,
          desktopFooter: _theme.default.content_footer_spacing_desktop
        },
        bannerHeaderHeights: {
          landing: _theme.default.banner_header_landing_min_height,
          subLanding: _theme.default.banner_header_subLanding_min_height
        },
        tabs: {
          desktop: {
            list: {
              borderBottomColor: _theme.default.tabs_list_border_bottom_color,
              borderRadius: _theme.default.tabs_list_border_radius,
              borderBottomStyle: _theme.default.tabs_list_border_bottom_style,
              borderBottomWidth: _theme.default.tabs_list_border_bottom_width,
              paddingBottom: _theme.default.tabs_list_padding_bottom,
              paddingLeft: _theme.default.tabs_list_padding_left,
              paddingRight: _theme.default.tabs_list_padding_right,
              paddingTop: _theme.default.tabs_list_padding_top
            },
            indicator: {
              display: _theme.default.tabs_mui_indicator_display
            },
            panel: {
              paddingBottom: _theme.default.tabs_panel_padding_bottom,
              paddingLeft: _theme.default.tabs_panel_padding_left,
              paddingRight: _theme.default.tabs_panel_padding_right,
              paddingTop: _theme.default.tabs_panel_padding_top,
              firstHeading: {
                color: _theme.default.tabs_panel_heading_first_color,
                fontFamily: _theme.default.tabs_panel_heading_first_font_family,
                fontSize: _theme.default.tabs_panel_heading_first_font_size
              }
            },
            scrollButtons: {
              width: _theme.default.tabs_scroll_buttons_width_desktop
            },
            tab: {
              backgroundColor: _theme.default.tabs_tab_background_color,
              borderBottomLeftRadius: _theme.default.tabs_tab_border_bottom_left_radius,
              borderBottomRightRadius: _theme.default.tabs_tab_border_bottom_right_radius,
              borderColor: _theme.default.tabs_tab_border_color,
              borderStyle: _theme.default.tabs_tab_border_style,
              borderTopLeftRadius: _theme.default.tabs_tab_border_top_left_radius,
              borderTopRightRadius: _theme.default.tabs_tab_border_top_right_radius,
              borderWidth: _theme.default.tabs_tab_border_width,
              color: _theme.default.tabs_tab_color,
              fontFamily: _theme.default.tabs_tab_font_family,
              fontSize: _theme.default.tabs_tab_font_size,
              marginBottom: _theme.default.tabs_tab_margin_bottom,
              marginLeft: _theme.default.tabs_tab_margin_left,
              marginLeftSubsequent: _theme.default.tabs_tab_margin_left_subsequent,
              marginRight: _theme.default.tabs_tab_margin_right,
              marginTop: _theme.default.tabs_tab_margin_top,
              paddingBottom: _theme.default.tabs_tab_padding_bottom,
              paddingLeft: _theme.default.tabs_tab_padding_left,
              paddingRight: _theme.default.tabs_tab_padding_right,
              paddingTop: _theme.default.tabs_tab_padding_top,
              textTransform: _theme.default.tabs_tab_text_transform,
              selected: {
                backgroundColor: _theme.default.tabs_tab_background_color_selected,
                borderBottomColor: _theme.default.tabs_tab_border_bottom_color_selected,
                borderBottomStyle: _theme.default.tabs_tab_border_bottom_style_selected,
                borderBottomWidth: _theme.default.tabs_tab_border_bottom_width_selected,
                borderRadius: _theme.default.tabs_tab_border_radius_selected,
                fontFamily: _theme.default.tabs_tab_font_family_selected,
                textTransform: _theme.default.tabs_tab_text_transform_selected,
                after: {
                  backgroundColor: _theme.default.tabs_tab_background_color_selected_after,
                  bottom: _theme.default.tabs_tab_bottom_selected_after,
                  left: _theme.default.tabs_tab_left_selected_after,
                  height: _theme.default.tabs_tab_height_selected_after,
                  width: _theme.default.tabs_tab_width_selected_after
                }
              }
            }
          },
          tablet: {
            list: {
              paddingLeft: _theme.default.tabs_list_padding_left_tablet,
              paddingRight: _theme.default.tabs_list_padding_right_tablet
            },
            scrollButtons: {
              width: _theme.default.tabs_scroll_buttons_width_tablet
            },
            tab: {
              marginLeftSubsequent: _theme.default.tabs_tab_margin_left_subsequent_tablet
            },
            panel: {
              paddingBottom: _theme.default.tabs_panel_padding_bottom_tablet,
              paddingLeft: _theme.default.tabs_panel_padding_left_tablet,
              paddingRight: _theme.default.tabs_panel_padding_right_tablet,
              paddingTop: _theme.default.tabs_panel_padding_top_tablet
            }
          },
          mobile: {
            list: {
              paddingLeft: _theme.default.tabs_list_padding_left_mobile,
              paddingRight: _theme.default.tabs_list_padding_right_mobile
            },
            scrollButtons: {
              width: _theme.default.tabs_scroll_buttons_width_mobile
            },
            tab: {
              marginLeftSubsequent: _theme.default.tabs_tab_margin_left_subsequent_mobile
            },
            panel: {
              paddingBottom: _theme.default.tabs_panel_padding_bottom_mobile,
              paddingLeft: _theme.default.tabs_panel_padding_left_mobile,
              paddingRight: _theme.default.tabs_panel_padding_right_mobile,
              paddingTop: _theme.default.tabs_panel_padding_top_mobile
            }
          }
        },
        zIndex: {
          navForeground: _theme.default.z_index_navigation_foreground,
          navBackground: _theme.default.z_index_navigation_background
        }
      },
      composite = (0, _object.isObject)(customTheme) ? merge(defaultTheme, customTheme) : defaultTheme;
    return (0, _styles.createTheme)(composite);
  };
exports.GetTheme = GetTheme;